import styled, { css } from 'styled-components';

interface IContainer {
  $disabled?: boolean;
  marginContainer?: string;
}
interface IHolder {
  margin?: number;
}

const fallbackTheme = {
  colors: {
    primary: '#ebe7ff',
    purpledeep: '#7764e4',
    border: '#eae7e7',
    purple: '#7764e4',
    whitesmoke: '#f5f5f5',
    secondary: '#424242',
    gray: '#a8a8a8',
  },
};

const getColor = (theme: any, key: keyof typeof fallbackTheme.colors) =>
  theme?.colors?.[key] || fallbackTheme.colors[key];

export const Container = styled.div<IContainer>`
  color: ${({ theme }: any) => getColor(theme, 'primary')};
  grid-column: span 2;
  @media (max-width: 1610px) {
    grid-column: span 2;
  }
  @media (max-width: 1030px) {
    grid-column: span 2;
  }
  @media (max-width: 770px) {
    grid-column: unset;
  }
  @media (max-width: 430px) {
    grid-column: unset;
  }
  display: flex;
  flex-direction: column;

  ${(props) => (props.marginContainer ? `margin: ${props.marginContainer};` : '')}
  & .button {
    height: 30px;
    width: 50%;
    border-radius: 30px;
    text-transform: capitalize;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    color: ${(props) => getColor(props.theme, 'purpledeep')};
    border: none;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: ${(props) => getColor(props.theme, 'primary')};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    border: 1px solid ${(props) => getColor(props.theme, 'border')};

    &:hover {
      border: 1px solid ${(props) => getColor(props.theme, 'purple')};
    }
  }

  @media (max-width: 1610px) {
    & .button {
      height: 26px !important;
    }
  }
  align-self: end;
`;
export const Holder = styled.div<IHolder>`
  width: 50%;
  margin-right: ${(props) => props.margin || 15}px;
  align-self: end;
`;
export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  background-color: ${({ theme }: any) => getColor(theme, 'whitesmoke')};
  border-radius: 10px 20px 20px 10px;
  border: 0.8px solid ${(props) => getColor(props.theme, 'border')};
  padding-right: 6px;
  align-items: center;
`;

export const Label = styled.label`
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  color: ${({ theme }: any) => getColor(theme, 'secondary')};
  font-weight: normal;
  display: inline-block;
  margin-bottom: 5px;

  @media (max-width: 1610px) {
    font-size: 10px;
  }
`;
interface IFileComponent {
  $drag?: boolean;
}
export const FileComponent = styled.div<IFileComponent>`
  margin-bottom: unset !important;
  background-color: ${({ theme }: any) => getColor(theme, 'whitesmoke')};
  color: ${({ theme }: any) => getColor(theme, 'gray')};
  border-radius: 10px;
  margin-top: unset !important;
  display: flex !important;
  height: 40px;
  font-size: 12px;
  ${(props) =>
    props.$drag &&
    css`
      border: 2px dashed #ccc;
    `}

  & input:first-child {
    display: none;
  }

  & input {
    margin-top: 0 !important;
    padding-left: 10px;
    padding-right: 10px;
    font-family: 'Roboto', sans-serif !important;
    font-size: 12px;
    margin-bottom: unset !important;
    color: ${({ theme }: any) => getColor(theme, 'secondary')} !important;
    background-color: transparent !important;
    width: 100% !important;
    border-radius: 10px;
    border: 0;
    cursor: default !important;
  }

  & input::placeholder {
    color: ${({ theme }: any) => getColor(theme, 'gray')};
  }

  @media (max-width: 1610px) {
    height: 35px !important;
    font-size: 10px !important;

    & input {
      height: 35px !important;
      font-size: 10px !important;
    }
  }
`;
